export function resolveEventListScrollElement(scrollElementRef, scrollContainerSelector) {
  // A DOM element passed directly is reactive when its owner stores the
  // callback-ref result in state. This avoids the first-mount race of an
  // object ref: changing `.current` does not trigger a React render, so the
  // virtualizer can otherwise remain attached to `null` until an unrelated
  // navigation or state update occurs.
  if (
    scrollElementRef &&
    typeof scrollElementRef.addEventListener === "function"
  ) {
    return scrollElementRef;
  }

  const refElement = scrollElementRef?.current;
  if (refElement && typeof refElement.addEventListener === "function") {
    return refElement;
  }

  if (typeof document === "undefined" || !scrollContainerSelector) {
    return null;
  }

  return document.querySelector(scrollContainerSelector);
}
